<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousDriverView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center style="margin-left: 0.5rem !important;">Driver Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="mt-2">
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Driver Type</label>
                  <model-list-select
                    :list="driverTypeList"
                    v-model="driverDetail.driverType"
                    option-value="driverTypeV"
                    option-text="driverTypeT"
                    placeholder="Select Driver Type"
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!driverDetail.driverType">{{
                  driverTypeError
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Driver Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="driverName"
                    name="driverName"
                    v-model="driverDetail.driverName"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!driverDetail.driverName">{{
                  addDriverError
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Contact No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="driverContact"
                    name="driverContact"
                    v-model="driverDetail.driverContact"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!driverDetail.driverContact">{{
                  addDriverError1
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25" v-if="driverDetail.driverType == '1'">
                <md-layout md-flex="100">
                  <label>Vehicle No.</label>
                  <model-list-select
                    :list="vehicleMasterList"
                    v-model="driverDetail.vehicleTruckId"
                    option-value="vehicleTruckId"
                    option-text="regdNo"
                    placeholder="Select Vehicle No. "
                  ></model-list-select>
                </md-layout>
                <span class="error" v-if="!driverDetail.vehicleTruckId">{{
                  addTruckError4
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Account No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="accountNo"
                    name="accountNo"
                    v-model="driverDetail.accountNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>ESIC</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="driverEsic"
                    name="driverEsic"
                    v-model="driverDetail.driverEsic"
                  ></b-form-input>
                </md-layout>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Working Year</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="driverWorkingYear"
                    name="driverWorkingYear"
                    v-model="driverDetail.driverWorkingYear"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <div class="mt-3">
              <h5 v-if="showDocSection.length > 0">
                <b-badge variant="info">Driver Documents</b-badge>
              </h5>
              <b-button
                v-else
                id="show-btn"
                size="sm"
                variant="dark"
                @click="AddMoreDocs"
                >Upload Document</b-button
              >
            </div>
            <div class="mt-3" v-if="showDocSection.length > 0">
              <table class="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Sr No.</th>
                    <th>Document Name</th>
                    <th>Upload Document</th>
                    <th>View</th>
                    <th>
                      <b-button
                        class="mt-2"
                        size="sm"
                        variant="outline-info"
                        @click="AddMoreDocs"
                        >Add More
                        <!-- @click="addQuotationFields" -->
                      </b-button>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in showDocSection" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <model-list-select
                        v-model="item.docName"
                        :list="docList"
                        option-value="docV"
                        option-text="docT"
                        placeholder="Select Document"
                      ></model-list-select>
                      <br />
                      <b-form-input :formatter="capitalizeAll"
                        v-if="item.docName == 'OTHERS'"
                        name="otherDocName"
                        id="otherDocName"
                        v-model="item.otherDocName"
                      ></b-form-input>
                    </td>

                    <td>
                      <md-input-container style="margin-top: -35px">
                        <md-file
                          @selected="onFileChangeKyc(index, item.docName)"
                          v-model="item.uploadedDoc"
                        ></md-file>
                      </md-input-container>
                    </td>

                    <td>
                      <a
                        v-if="item.uploadedDoc != ''"
                        :href="
                          `${docURL}/DRIVERMASTER_Uploads/` +
                          item.uploadedDoc
                        "
                        target="_blank"
                        download
                        >View Document - {{ index + 1 }}</a
                      >
                    </td>

                    <td>
                      <b-button
                        variant="outline-danger"
                        @click="removeDoc(index)"
                        size="sm"
                        >Remove</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <md-layout md-gutter class="mrgtop-button mt-3">
              <md-layout class="justify-content-center">
                <b-button
                  class="smbutnWidth mt-3"
                  variant="primary"
                  id="addButtonLoader"
                  @click="addNewDriver"
                  >Save</b-button
                >

                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>

<script>
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/driverMaster");

      if (globalPermissionStatus("driverMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("driverMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      // if (
      //   this.$sessionsStorage.get("editDriverId") != "" &&
      //   this.$sessionsStorage.get("editDriverId") != undefined
      // ) {
      this.viewEditDriver();
      // }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      isLoading: false,
      showDocSection: [],
      docList: [
        {
          docV: "PAN_CARD",
          docT: "PAN CARD",
        },
        {
          docV: "ADDRESS_PROOF",
          docT: "ADDRESS PROOF",
        },
        {
          docV: "LICENSE",
          docT: "LICENSE",
        },

        {
          docV: "OTHERS",
          docT: "OTHERS",
        },
      ],
      docURL: URL_BASE_DOC,
      alert: {
        content:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      driverTypeError: "",
      driverTypeList: [
        {
          driverTypeV: "1",
          driverTypeT: "Permanent",
        },
        {
          driverTypeV: "2",
          driverTypeT: "Temporary",
        },
      ],
      driverDetail: {
        vehicleTruckId: "",

        driverType: "",

        driverId: "",
        driverName: "",
        driverContact: "",
        driverWorkingYear: "",
        driverEsic: "",
        accountNo: "",
        uploadDriverDoc: "",
      },
      driverNameDetail: [],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Update"
            : "New",
      },

      validate: true,
      addDriverError: "",
      addDriverError1: "",
      addTruckError4: "",
    };
  },

  mounted() {
    this.JqueryFun();
  },
  beforeDestroy() {
    this.$sessionsStorage.set("editDriverId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
     CustomLoader,
  },
  computed: {
    viewDocument() {
      return this.driverDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
  },
  methods: {
    removeDoc(index) {
      this.showDocSection.splice(index, 1);
    },
    AddMoreDocs() {
      let obj = {
        docName: "",
        otherDocName: "",
        uploadedDoc: "",
      };
      this.showDocSection.push(obj);
    },
    onFileChangeKyc(index, DOCNAME) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", index);
        formData.append(
          "staticFileName",
          this.driverDetail.driverName + "_" + DOCNAME
        );
        formData.append("upload_dir_folderName", "DRIVERMASTER_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          this.showDocSection[index].uploadedDoc = result.data;

          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    vehicleMasterFilter(list, query) {
      return this.driverNameDetail.filter((x) => {
        return x.regdNo.toLowerCase().includes(query.toLowerCase());
      });
    },
    selectVehicleName(item) {
      this.driverDetail.vehicleTruckId = item.vehicleTruckId;
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleMaster").DataTable();
      });
    },
    onClose(type) {
      this.$router.push({
        path: "/vehicle/viewDriverDetail",
      });
    },

    previousDriverView() {
      this.$router.push({
        path: "/vehicle/viewDriverDetail",
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateAddDriverForm() {
      let validate_new = true;

      if (this.driverDetail.driverName == "") {
        $("#driverName").focus();
        this.addDriverError = "Enter Driver Name";
        validate_new = false;
      }
      if (this.driverDetail.driverContact == "") {
        $("#driverContact").focus();
        this.addDriverError1 = "Enter Contact No.";
        validate_new = false;
      }

      if (
        this.driverDetail.vehicleTruckId == "" &&
        this.driverDetail.driverType == "1"
      ) {
        $("#vehicleTruckId").focus();
        this.addTruckError4 = "Select Vehicle No.";
        validate_new = false;
      }

      if (this.driverDetail.driverType == "") {
        $("#driverType").focus();
        this.driverTypeError = "Select Driver Type";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addNewDriver() {
      this.driverDetail["showDocSection"] = this.showDocSection;
      this.validateAddDriverForm();

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addDriver.php`,
          data: JSON.stringify(this.driverDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json,",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
          })
          .catch((error) => {});
      }
    },

    viewEditDriver() {
      let edit_Driver = {
        edit: "edit",
        driverId: this.$sessionsStorage.get("editDriverId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewEditDriver.php`,
        data: JSON.stringify(edit_Driver),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.vehicleDetail.length > 0) {
              this.driverNameDetail = data.vehicleDetail;
            }
            if (data.editDriver.length > 0) {
              if (
                data.editDriver[0].uploadedDoc != null &&
                data.editDriver[0].uploadedDoc != ""
              ) {
                let uploadedDocArr = data.editDriver[0].uploadedDoc.split(",");
                let uploadedDocName = data.editDriver[0].docName.split(",");
                let otherDocNameArr = data.editDriver[0].otherDocName.split(
                  ","
                );
                for (let i = 0; i < uploadedDocArr.length; i++) {
                  let obj = {
                    docName: uploadedDocName[i],
                    otherDocName: otherDocNameArr[i],
                    uploadedDoc: uploadedDocArr[i],
                  };
                  this.showDocSection.push(obj);
                }
              }
              Object.keys(this.driverDetail).map((x) => {
                this.driverDetail[x] = data.editDriver[0][x] || "";
                // this.viewEditClientDetail = data.editClient;
                //  console.log("fsf",data.truckSizeDetails)
              });
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// driverMaster.vue?39ae76fa